import { render, staticRenderFns } from "./bot-response-text-message.vue?vue&type=template&id=65b1d588"
import script from "./bot-response-text-message.vue?vue&type=script&lang=js"
export * from "./bot-response-text-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports